import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    this.element.style.transition = "opacity 150ms ease, transform 150ms ease"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateX(0.5rem)"
    setTimeout(() => this.element.remove(), 150)
  }
}
